// extracted by mini-css-extract-plugin
export default {"container":"Error_container__1yNmK","text":"Error_text__03o5x"};